<div class="mx-auto w-full max-w-7xl px-4 py-6 lg:px-6">
  <div class="space-y-6">
    <app-card-information
      title="Logger production"
      [collapsible]="true"
      description="Controla por separado los logs del frontend y la sesión de diagnóstico del backend.">
      <div class="flex flex-col gap-4 md:flex-row md:items-stretch">
        <button
          type="button"
          (click)="toggleLogger()"
          class="inline-flex items-center gap-3 rounded-2xl border px-4 py-3 text-left shadow-sm transition-colors"
          [class.border-pae-green]="loggerEnabled()"
          [class.bg-pae-green-5]="loggerEnabled()"
          [class.border-pae-grey-3]="!loggerEnabled()"
          [class.bg-pae-grey-1]="!loggerEnabled()">
          <span
            class="flex h-11 w-11 items-center justify-center rounded-full text-sm font-bold"
            [class.bg-pae-green]="loggerEnabled()"
            [class.text-pae-white]="loggerEnabled()"
            [class.bg-pae-grey-2]="!loggerEnabled()"
            [class.text-gray-700]="!loggerEnabled()">
            {{ loggerEnabled() ? 'ON' : 'OFF' }}
          </span>
          <span class="flex flex-col">
            <span class="text-sm font-semibold text-gray-900">Logger frontend</span>
            <span class="text-xs text-gray-600">
              {{ loggerEnabled() ? 'Logger habilitado' : 'Logger deshabilitado' }}
            </span>
            <span class="text-xs text-gray-600">
              sessionStorage['logger'] = {{ loggerEnabled() ? 'true' : 'null' }}
            </span>
          </span>
        </button>

        <button
          type="button"
          (click)="toggleLogicLogger()"
          class="inline-flex items-center gap-3 rounded-2xl border px-4 py-3 text-left shadow-sm transition-colors"
          [class.border-pae-green]="diagnosticSession.isActive()"
          [class.bg-pae-green-5]="diagnosticSession.isActive()"
          [class.border-pae-grey-3]="!diagnosticSession.isActive()"
          [class.bg-pae-grey-1]="!diagnosticSession.isActive()">
          <span
            class="flex h-11 w-11 items-center justify-center rounded-full text-sm font-bold"
            [class.bg-pae-green]="diagnosticSession.isActive()"
            [class.text-pae-white]="diagnosticSession.isActive()"
            [class.bg-pae-grey-2]="!diagnosticSession.isActive()"
            [class.text-gray-700]="!diagnosticSession.isActive()">
            {{ diagnosticSession.isActive() ? 'ON' : 'OFF' }}
          </span>
          <span class="flex flex-col">
            <span class="text-sm font-semibold text-gray-900">Logger lógica (backend)</span>
            <span class="text-xs text-gray-600">
              {{ diagnosticSession.isActive() ? 'Finalizar y descargar diagnóstico' : 'Iniciar diagnóstico' }}
            </span>
            @if (diagnosticSession.isActive()) {
            <span class="mt-1 text-xs text-gray-600">
              Sesión: {{ diagnosticSession.diagnosticSessionId() }} · {{ diagnosticSession.requestCount() }}/60
              solicitudes
            </span>
            }
          </span>
        </button>
      </div>
    </app-card-information>

    <app-card-information
      title="Selector libre"
      [collapsible]="true"
      description="Usa el selector nativo del portal pero sin restricciones de contexto.">
      <app-shiptos-dropdown [showTitle]="true" class="block"></app-shiptos-dropdown>
    </app-card-information>

    @for (group of debugGroups(); track group.title) {
    <app-card-information [title]="group.title" [description]="group.description" [collapsible]="true">
      @if (isTableGroup(group.title)) { @let filteredItems = getFilteredGroupItems(group);

      <div
        class="mb-4 flex flex-col gap-3 rounded-lg border border-pae-grey-3 bg-pae-grey-1 p-3 md:flex-row md:items-end md:justify-between">
        <label class="flex w-full flex-col gap-1 md:max-w-md">
          <span class="text-xs font-semibold uppercase tracking-[0.18em] text-pae-purple-25">Buscar propiedad</span>
          <input
            type="search"
            [value]="getPropertySearch(group.title)"
            (input)="setPropertySearch(group.title, $event)"
            placeholder="Ej: isAxion, getUsuario"
            class="h-11 rounded-lg border border-pae-grey-3 bg-white px-3 text-sm font-medium text-gray-900 outline-none transition focus:border-pae-purple-25 focus:ring-2 focus:ring-pae-purple-5" />
        </label>

        <div class="rounded-lg border border-pae-grey-3 bg-white px-4 py-3 text-sm text-gray-700">
          <span class="font-semibold text-gray-900">{{ filteredItems.length }}</span>
          de
          <span class="font-semibold text-gray-900">{{ group.items.length }}</span>
          propiedades
        </div>
      </div>

      <div class="overflow-hidden rounded-lg border border-pae-grey-3 bg-white shadow-sm">
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-pae-grey-3 text-left text-sm">
            <thead class="bg-pae-grey-1">
              <tr>
                <th scope="col" class="px-4 py-3 text-xs font-semibold uppercase tracking-[0.18em] text-pae-purple-25">
                  Propiedad
                </th>
                <th scope="col" class="px-4 py-3 text-xs font-semibold uppercase tracking-[0.18em] text-pae-purple-25">
                  Tipo
                </th>
                <th scope="col" class="px-4 py-3 text-xs font-semibold uppercase tracking-[0.18em] text-pae-purple-25">
                  Valor
                </th>
                <th scope="col" class="px-4 py-3 text-xs font-semibold uppercase tracking-[0.18em] text-pae-purple-25">
                  Estado
                </th>
              </tr>
            </thead>

            <tbody class="divide-y divide-pae-grey-3">
              @for (item of filteredItems; track item.key) {
              <tr class="transition-colors hover:bg-pae-grey-1">
                <td class="px-4 py-3 align-top">
                  <p class="font-semibold text-gray-900">{{ item.key }}</p>
                  @if (item.label !== item.key) {
                  <p class="mt-1 text-xs text-gray-500">{{ item.label }}</p>
                  }
                </td>
                <td class="px-4 py-3 align-top">
                  <span
                    class="inline-flex rounded-full bg-pae-purple-5 px-3 py-1 text-xs font-semibold text-pae-purple-25 ring-1 ring-inset ring-pae-grey-3">
                    {{ item.kind }}
                  </span>
                </td>
                <td class="px-4 py-3 align-top">
                  @if (item.kind === 'boolean') {
                  <span
                    class="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold ring-1 ring-inset"
                    [class.bg-pae-green]="item.active"
                    [class.text-pae-white]="item.active"
                    [class.ring-pae-green]="item.active"
                    [class.bg-pae-red]="item.active === false"
                    [class.text-pae-white]="item.active === false"
                    [class.ring-pae-red]="item.active === false">
                    <span class="h-2 w-2 rounded-full bg-current"></span>
                    {{ item.rendered }}
                  </span>
                  } @else {
                  <span class="block max-w-xl break-words font-medium text-gray-900">{{ item.rendered }}</span>
                  }
                </td>
                <td class="px-4 py-3 align-top">
                  <span class="font-medium text-gray-700">
                    {{ item.active === true ? 'Habilitado' : item.active === false ? 'Deshabilitado' : 'Valor' }}
                  </span>
                </td>
              </tr>
              } @empty {
              <tr>
                <td colspan="4" class="px-4 py-8 text-center text-sm font-medium text-gray-600">
                  No hay propiedades que coincidan con la busqueda.
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      } @else {
      <div class="grid gap-4 md:grid-cols-2 xl:grid-cols-2">
        @for (item of group.items; track item.key) {
        <article
          class="group overflow-hidden rounded-2xl border border-pae-grey-3 bg-gradient-to-br from-white via-white to-pae-grey-1 p-4 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md"
          [class.border-pae-green]="item.kind === 'boolean' && item.active"
          [class.bg-pae-green-5]="item.kind === 'boolean' && item.active"
          [class.border-pae-red]="item.kind === 'boolean' && item.active === false"
          [class.bg-red-50]="item.kind === 'boolean' && item.active === false">
          <div class="flex items-start justify-between gap-3">
            <div class="min-w-0">
              <p class="truncate text-[11px] font-semibold uppercase tracking-[0.24em] text-pae-purple-25">
                {{ item.key }}
              </p>
              <h3 class="mt-1 text-base font-semibold text-gray-900">{{ item.label }}</h3>
            </div>

            @if (item.kind === 'boolean') {
            <span
              class="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold ring-1 ring-inset"
              [class.bg-pae-green]="item.active"
              [class.text-pae-white]="item.active"
              [class.ring-pae-green]="item.active"
              [class.bg-pae-red]="item.active === false"
              [class.text-pae-white]="item.active === false"
              [class.ring-pae-red]="item.active === false"
              [class.bg-pae-grey-2]="item.active === null"
              [class.text-gray-700]="item.active === null"
              [class.ring-pae-grey-3]="item.active === null">
              <span class="h-2 w-2 rounded-full" [class.bg-current]="true"></span>
              {{ item.rendered }}
            </span>
            } @else {
            <span
              class="rounded-full bg-pae-purple-5 px-3 py-1 text-xs font-semibold text-pae-purple-25 ring-1 ring-inset ring-pae-grey-3">
              {{ item.kind }}
            </span>
            }
          </div>

          <div class="mt-4 border-t border-pae-grey-3 pt-4">
            @if (item.kind === 'boolean') {
            <div class="flex items-center justify-between gap-3">
              <div>
                <p class="text-xs uppercase tracking-[0.24em] text-pae-purple-25">Estado</p>
                <p class="mt-1 text-sm font-semibold text-gray-900">
                  {{ item.active === true ? 'Habilitado' : item.active === false ? 'Deshabilitado' : 'Sin dato' }}
                </p>
              </div>

              <span class="rounded-full bg-white px-3 py-1 text-xs font-medium text-gray-600 shadow-sm">
                {{ item.rendered }}
              </span>
            </div>
            } @else {
            <div class="flex items-center justify-between gap-3">
              <div>
                <p class="text-xs uppercase tracking-[0.24em] text-pae-purple-25">Salida</p>
                <p class="mt-1 text-sm font-semibold text-gray-900">Valor computado</p>
              </div>

              <span class="rounded-full bg-white px-3 py-1 text-xs font-medium text-gray-600 shadow-sm">
                {{ item.kind }}
              </span>
            </div>

            <pre
              class="mt-4 max-h-48 overflow-auto rounded-2xl bg-[#f8f6fb] p-4 text-[13px] leading-6 text-gray-800 whitespace-pre-wrap break-words ring-1 ring-inset ring-pae-grey-3">
{{ item.rendered }}</pre
            >
            }
          </div>
        </article>
        }
      </div>
      }
    </app-card-information>
    }

    <section class="grid gap-4 xl:grid-cols-2">
      <app-card-information title="Shipto seleccionado" [collapsible]="true">
        <pre
          class="max-h-[28rem] overflow-auto rounded-2xl bg-pae-grey-1 p-4 text-xs leading-5 text-gray-800 whitespace-pre-wrap break-words">
{{ userDataStore.shiptoSelected() | json }}</pre
        >
      </app-card-information>

      <app-card-information title="Session completa" [collapsible]="true">
        <pre
          class="max-h-[28rem] overflow-auto rounded-2xl bg-pae-grey-1 p-4 text-xs leading-5 text-gray-800 whitespace-pre-wrap break-words">
{{ userDataStore.userData() | json }}</pre
        >
      </app-card-information>
    </section>
  </div>
</div>
